<template>
  <div class="row p-5">
    <div class="row-12">
      <router-link to="/">Volver</router-link>
    </div>
    <div class="col-12 text-center">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><b>POLÍTICA
      DE TRATAMIENTO DE LA INFORMACIÓN</b></span></span></font></font></font>

      <p lang="es-CO" align="center" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><b>ABACO
      LATAM S.A.S.</b></span></span></font></font></font></p>
      <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
      <br/>
      </p>
      <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">En
      cumplimiento de la Ley 1581 de 2012 y el decreto 1377 de 2013,
      vigentes en la República de Colombia, y cualquier otra norma
      aplicable en la materia, la siguiente es la Política de Tratamiento
      de la Información de ABACO LATAM S.A.S.</span></font></font></font></p>
    </div>
    <div class="col-12">
    <ol>
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><b>DATOS
        DEL RESPONSABLE TRATAMIENTO DE INFORMACIÓN</b></span></span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>

    </p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">ABACO
    LATAM S.A.S.</span></font></font></font></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none"><a name="_Hlk498447162"></a>
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">NIT
    </span>901.102.558-4</font></font></font></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><span style="text-decoration: none">Domicilio:
    Bogotá</span></span></span></font></font></font></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; text-decoration: none">
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><span style="text-decoration: none">Dirección:
    Calle 69A #9-47</span></span></span></font></font></font></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; text-decoration: none">
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><span style="text-decoration: none">Correo
    Electrónico: info@abacolatam.com</span></span></span></font></font></font></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; text-decoration: none"><a name="_Hlk497483818"></a>
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><span style="text-decoration: none">Teléfono:
    +57 3183061739</span></span></span></font></font></font></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; text-decoration: none">
    <br/>

    </p>
    <ol start="2">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none"><a name="_Toc493681899"></a>
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><b>DISPOSICIONES</b></span></span><span lang="es-CO"><b>
      GENERALES  </b></span></font></font></font>
      </p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 0.64cm; margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>

    <ol>
      <ol start="1">
        <li>
          <p style="margin-bottom: 0cm; line-height: 100%"><a name="_Toc493681900"></a>
          <font face="Arial, serif"><font size="2" style="font-size: 11pt">
            <span lang="es-CO"><b>Objetivo</b>
            </span></font></font>
          </p>
        </li>
      </ol>
    </ol>
    <p lang="es-CO" style="margin-left: 1cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">La
    presente Política de Tratamiento de la Información tiene como
    objetivo garantizar el adecuado cumplimiento de las normas aplicables
    en materia de protección de datos personales aplicables y poner en
    conocimiento el uso que la ABACO LATAM S.A.S. le da a la información
    proporcionada por los Titulares, e informar sobre los procedimientos
    y mecanismos  al manejo de los Datos Personales recopilados para las
    finalidades previstas con la autorización previa.</span></font></font></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <ol>
      <ol start="2">
        <li><p style="margin-bottom: 0cm; line-height: 100%"><a name="_Toc493681901"></a>
        <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Legislación
          Aplicable</b></span></font></font></p></li>
      </ol>
    </ol>
    <p lang="es-CO" style="margin-left: 1cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">La
    presente Política de Tratamiento de la Información  fue elaborada
    de conformidad con las disposiciones contenidas en los artículos 15
    y 20 de la Constitución Política, la Ley 1581 de 2012 y sus
    decretos reglamentarios, en especial el Decreto 1377 de 2013.</span></font></font></p>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <ol>
      <ol start="3">
        <li><p style="margin-bottom: 0cm; line-height: 100%"><a name="_Toc493681902"></a>
        <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Ámbito
          de </b></span></font></font><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>aplicación</b></span></font></font></p></li>
      </ol>
    </ol>
    <p lang="es-CO" style="margin-left: 1cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">La
    presente Política de Tratamiento de la Información es aplicable al
    tratamiento de los datos personales registrados en cualquier base de
    datos que los haga susceptibles de Tratamiento por parte de ABACO
    LATAM S.A.S., bien sea en calidad de Responsable y/o Encargado.</span></font></font></p>
    <p lang="es-CO" style="margin-bottom: 0cm; line-height: 100%"><br/>
    </p>
    <ol>
      <ol start="4">
        <li><p style="margin-bottom: 0cm; line-height: 100%"><a name="_Toc493681903"></a>
          <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Definiciones</b></span></font></font></p></li>
      </ol>
    </ol>
    <p lang="es-CO" style="margin-left: 1cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Para
    los efectos de aplicación de la presente Política, y en
    concordancia con lo establecido en el artículo 3 de la ley 1581 de
    2012 y en el artículo 3 del Decreto 1377 de 2013 se entiende por: </span></font></font>
    </p>
    <p lang="es-CO" style="margin-bottom: 0cm; line-height: 100%"><br/>
    </p>
    <ol type="a">
      <li><p align="justify" style="margin-bottom: 0.09cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Autorización:
      </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Consentimiento
      previo, expreso e informado del Titular para llevar a cabo el
        tratamiento de sus DATOS personales.</span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0.09cm; border: none; padding: 0cm; line-height: 100%">
    <br/>
    <br/>
    </p>
    <ol type="a" start="2">
      <li><p align="justify" style="margin-bottom: 0.09cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Aviso
      de Privacidad: </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Documento
      físico, electrónico o en cualquier otro formato, generado por el
      responsable, dirigido al titular para el Tratamiento de sus Datos
      Personales, mediante el cual se le informar acerca de la existencia
      de las políticas  del tratamiento de la información, que le serán
      aplicables a sus datos, la forma de acceder a las mismas y la
      finalidad para la cual serán usados dichos datos. </span></font></font></font>
      </p></li>
      <li><p align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Base
      de Datos: </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Conjunto
      organizado de Datos Personales que sea objeto de tratamiento. Puede
      ser automatizada o física de acuerdo a su forma de Tratamiento o
        almacenamiento.</span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="4">
      <li><p align="justify" style="margin-bottom: 0.09cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Dato
      Personal: </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Cualquier
      información vinculada o que pueda asociarse a una o varias personas
        naturales determinadas o determinables.</span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="5">
      <li><p align="justify" style="margin-bottom: 0.09cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Dato
      Privado: </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Aquel
      que por su naturaleza íntima o reservada sólo es relevante para el
        Titular.</span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="6">
      <li><p align="justify" style="margin-bottom: 0.09cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Dato
      Público: </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Aquel
      que no sea Semiprivado, Privado o Sensible. Son considerados Datos
      Públicos, entre otros, los datos relativos al estado civil de las
      personas, a su profesión u oficio y a su calidad de comerciante o
      de servidor público. Por su naturaleza, los datos públicos pueden
      estar contenidos, entre otros, en registros públicos, documentos
      públicos, gacetas y boletines oficiales y sentencias judiciales
      debidamente ejecutoriadas que no estén sometidas a reserva. </span></font></font></font>
      </p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="7">
      <li><p align="justify" style="margin-bottom: 0.09cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Dato
      Sensible: </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Aquel
      que afecta la intimidad del Titular o cuyo uso indebido puede
      generar su discriminación, incluyendo pero sin limitarse a datos
      que revelen el origen racial o étnico, la orientación política,
      las convicciones religiosas o filosóficas, la pertenencia a
      sindicatos, organizaciones sociales, de derechos humanos o que
      promueva intereses de cualquier partido político o que garanticen
      los derechos y garantías de partidos políticos de oposición, así
      como los datos relativos a la salud, a la vida sexual y los datos
      biométricos. </span></font></font></font>
      </p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="8">
      <li><p align="justify" style="margin-bottom: 0.09cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Encargado
      del Tratamiento: </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Persona
      natural o jurídica, pública o privada, que por sí misma o en
      asocio con otros, realice el tratamiento de Datos Personales por
      cuenta del Responsable del Tratamiento. </span></font></font></font>
      </p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="9">
      <li><p align="justify" style="margin-bottom: 0.09cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Responsable
      del Tratamiento: </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Persona
      natural o jurídica, pública o privada, que por sí misma o en
      asocio con otros, decida sobre la Base de Datos y/o el Tratamiento
        de los datos.</span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="10">
      <li><p align="justify" style="margin-bottom: 0.09cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Titular:
      </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Persona
      natural cuyos Datos Personales sean objeto de Tratamiento. </span></font></font></font>
      </p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="11">
      <li><p align="justify" style="margin-bottom: 0.09cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Transferencia:
      </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">La
      Transferencia de datos tiene lugar cuando el Responsable y/o
      Encargado del Tratamiento de datos personales, ubicado en Colombia,
      envía la información o los datos personales a un receptor, que a
      su vez es responsable del tratamiento y se encuentra dentro o fuera
        del país.</span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="12">
      <li><p align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Transmisión:
      </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Tratamiento
      de Datos Personales que implica la comunicación de los mismos
      dentro o fuera del territorio de la República de Colombia cuando
      tenga por objeto la realización de un Tratamiento por el Encargado
      por cuenta del Responsable. </span></font></font></font>
      </p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="13">
      <li><p align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Tratamiento:
      </b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Cualquier
      operación o conjunto de operaciones sobre Datos Personales, tales
        como la recolección, almacenamiento, uso, circulación o supresión.</span></font></font></font></p></li>
    </ol>
    <p align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <font color="#000000"> </font>
    </p>
    <ol>
      <ol start="5">
        <li><p style="margin-bottom: 0cm; line-height: 100%"><a name="_Toc493681904"></a>
        <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Principios
          rectores aplicables al Tratamiento de Datos Personales</b></span></font></font></p></li>
      </ol>
    </ol>
    <p lang="es-CO" style="margin-left: 1cm; margin-bottom: 0cm; line-height: 100%">
    <br/>

    </p>
    <p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Con
    el fin de garantizar  el  Tratamiento de Datos Personales que realice
    ABACO LATAM S.A.S. como Responsable y/o Encargado de la información,
    </span></font></font><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">aplicarán
    los siguientes principios, en los términos del artículo 4 de la Ley
    1581 de 2012:</span></font></font></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a">
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Legalidad:</b></span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">&nbsp;El
      </span></font></font></font><font color="#1b1b1b"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Tratamiento</span></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">
      que realice ABACO LATAM S.A.S. sobre los Datos Personales estará
      sujeto a lo establecido en la Ley 1581 de 2012 y demás normas
        aplicables en la materia.</span></font></font></font></p></li>
    </ol>
    <p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font color="#000000">&nbsp;</font></p>
    <ol type="a" start="2">
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Finalidad</b></span></font></font><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">:&nbsp;El
      Tratamiento que realice ABACO LATAM S.A.S. obedecerá a una
      finalidad legítima de acuerdo con la Constitución y la ley, la
        cual será informada al Titular.</span></font></font></p></li>
    </ol>
    <p align="justify" style="margin-bottom: 0cm; line-height: 100%">&nbsp;</p>
    <ol type="a" start="3">
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Libertad:</b></span></font></font><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">&nbsp;El
      Tratamiento sólo puede ejercerse con el consentimiento, previo,
      expreso e informado del Titular. Los Datos Personales no podrán ser
      obtenidos o divulgados sin previa autorización, o en ausencia de
        mandato legal o judicial que releve el consentimiento.</span></font></font></p></li>
    </ol>
    <p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font color="#000000">&nbsp;</font></p>
    <ol type="a" start="4">
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Veracidad
      o Calidad:</b></span></font></font><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">&nbsp;La
      información sujeta a Tratamiento debe ser veraz, completa, exacta,
      actualizada, comprobable y comprensible. Se prohíbe el Tratamiento
      de datos parciales, incompletos, fraccionados o que induzcan a
        error.</span></font></font></p></li>
    </ol>
    <p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font color="#000000">&nbsp;</font></p>
    <ol type="a" start="5">
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Transparencia:</b></span></font></font><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">&nbsp;En
      el Tratamiento se garantizará el derecho del Titular a obtener de
      ABACO LATAM S.A.S. como Responsable y/o Encargado, en cualquier
      momento y sin restricciones, información acerca de la existencia de
        datos que le conciernan.</span></font></font></p></li>
    </ol>
    <p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font color="#000000">&nbsp;</font></p>
    <ol type="a" start="6">
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Acceso
      y Circulación Restringida:</b></span></font></font><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">&nbsp;El
      Tratamiento se sujeta a los límites que se derivan de la naturaleza
      de los Datos Personales, de las disposiciones de la Ley 1581 de 2012
      y la Constitución. En este sentido, el Tratamiento sólo podrá
      hacerse por personas autorizadas por el Titular y/o por las personas
        previstas en la Ley 1581 de 2012.</span></font></font></p></li>
    </ol>
    <p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font color="#000000">&nbsp;</font></p>
    <ol type="a" start="7">
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Seguridad:</b></span></font></font><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">&nbsp;La
      información sujeta a Tratamiento por ABACO LATAM S.A.S. como
      Responsable del Tratamiento y/o Encargado del, se deberá manejar
      con las medidas técnicas, humanas y administrativas que sean
      necesarias para otorgar seguridad a los registros evitando su
      adulteración, pérdida, consulta, uso o acceso no autorizado o
        fraudulento.</span></font></font></p></li>
    </ol>
    <p align="justify" style="margin-bottom: 0cm; line-height: 100%"><font color="#000000">&nbsp;</font></p>
    <ol type="a" start="8">
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Confidencialidad:</b></span></font></font><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">&nbsp;Todas
      las personas que intervengan en el Tratamiento de Datos Personales
      que no tengan la naturaleza de públicos están obligadas a
      garantizar la reserva de la información, inclusive después de
      finalizada su relación con alguna de las labores que comprende el
      Tratamiento, pudiendo sólo realizar suministro o comunicación de
      Datos Personales cuando ello corresponda al desarrollo de las
      actividades autorizadas en la Ley 1581 de 2012 y en los términos de
        la misma.</span></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>

    </p>
    <ol start="3">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><b>TRATAMIENTO
      AL CUAL ESTARÁN SOMETIDOS LOS DATOS PERSONALES E INFORMACIÓN
        COMERCIAL Y SU FINALIDAD</b></span></span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none"><a name="_Hlk498445106"></a>
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Los
    datos personales serán recolectados, almacenados, transmitidos,
    transferidos, procesados y usados para todos aquellos aspectos
    inherentes a los productos ofrecidos por ABACO LATAM S.A.S., y la
    ejecución de los contratos con clientes, proveedores, empleados y
    demás colaboradores, lo que implica el uso de los datos serán
    usados para los siguientes fines:</span></font></font></font></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>

    </p>
    <ol>
      <ol>
        <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
        <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Clientes
          y Usuarios</b></span></font></font></p></li>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <ol type="a">
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Realizar
      ante los operadores de información (Datacrédito, Cifin y/o
      cualquier otra entidad que llegue a manejar bases de datos con los
      mismos objetivos), las siguientes actividades: (a) Reportar con
      fines estadísticos, de control, supervisión, evaluación de
      riesgos y demás que señalen las políticas de ABACO LATAM S.A.S.
      y/o las normas vigentes colombianas, sus datos personales
      (incluyendo financieros y comerciales) y la información relacionada
      con el surgimiento de cualquier obligación, novedad, modificación,
      extinción, cumplimiento o incumplimiento de las obligaciones
      contraídas o que llegue a contraer en favor de ábaco y (b)
      Reportar cualquier otro dato que se estime pertinente con relación
      a la existencia de deudas vencidas sin cancelar o con la utilización
      indebida de los productos y/o servicios prestados u ofrecidos por
      ABACO LATAM S.A.S., todo lo anterior en los términos de la Ley 1266
        de 2008.</span></font></font></p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Solicitar
      y consultar a los operadores de información sus datos (incluyendo
      financieros y comerciales) con el fin de: (a) Obtener información
      referente a las relaciones comerciales establecidas con cualquier
      entidad financiera o comercial y (b) Confirmar datos para iniciar o
      mantener una relación contractual. La permanencia de la información
      del dato positivo o negativo, según sea el caso, será la que la
        legislación señale, en especial la Ley 1266 de 2008.</span></font></font></p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Cumplir
      las obligaciones contraídas por ABACO LATAM S.A.S. con sus clientes
      y usuarios. </span></font></font>
      </p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Enviar
      información sobre los productos que ofrece ABACO LATAM S.A.S. a sus
      clientes y usuarios. </span></font></font>
      </p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Enviar
      a sus clientes y usuarios información sobre cambios en las
      condiciones de los productos ofrecidos por ABACO LATAM S.A.S. </span></font></font>
      </p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Enviar
      a sus clientes y usuarios al correo físico, electrónico, celular o
      dispositivo móvil, vía mensajes de texto (SMS y/o MMS) o a través
      de cualquier otro medio análogo y/o digital de comunicación creado
      o por crearse, información comercial, publicitaria o promocional
      sobre los productos de ABACO LATAM S.A.S., eventos y/o promociones
      de tipo comercial o no de estas, con el fin de impulsar, invitar,
      dirigir, ejecutar, informar y de manera general, llevar a cabo
      campañas, promociones o concursos de carácter comercial o
      publicitario, adelantados por ABACO LATAM S.AS y/o por terceras
        personas.</span></font></font></p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Tratar
      los datos de los clientes y usuarios de ABACO LATAM S.A.S.
        suministrados por terceros para las finalidades aquí señaladas.</span></font></font></p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Trasferir
      o transmitir los Datos Personales de los clientes y usuarios a
      terceras personas en Colombia y en el exterior para su uso
      comercial. </span></font></font>
      </p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Transferir
      o transmitir los datos personales de los clientes y usuarios de
      ABACO LATAM S.A.S., a Encargados del Tratamiento en Colombia y en el
      exterior cuando ello sea necesario para la ejecución de los
      contratos con los clientes y usuarios de ABACO LATAM S.A.S. </span></font></font>
      </p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Para
      el fortalecimiento de las relaciones con sus clientes y usuarios
      mediante el envío de información relevante, la adquisición de los
      productos y evaluación de la calidad de los productos de ABACO
        LATAM S.A.S.</span></font></font></p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Controlar
      el acceso a las oficinas de ABACO LATAM S.A.S., y establecer medidas
      de seguridad, incluyendo el establecimiento de zonas videovigiladas,
      </span></font></font>
      </p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Dar
      respuesta a consultas, peticiones, quejas y reclamos que sean
      realizadas por los titulares y transmitir los Datos Personales a
      organismos de control y demás autoridades que en virtud de la ley
      aplicable deban recibir los Datos Personales. </span></font></font>
      </p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Registrar
      los datos personales en los sistemas de información de ABACO LATAM
      S.A.S. y en sus bases de datos comerciales y operativas. </span></font></font>
      </p></li>
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Los
      demás fines necesarios para dar cumplimiento a los contratos con
      los clientes y usuarios de ABACO LATAM S.A.S. y demás fines
      contenidos en la Política de Tratamiento de la Información de
        ABACO LATAM S.A.S.</span></font></font></p></li>
    </ol>
    <ol>
      <ol start="2">
        <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Proveedores</b></span></font></font></p></li>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Para
        ejecutar los contratos con los proveedores de ABACO LATAM S.A.S.</span></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 0.64cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="2">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%"><a name="_Hlk495306373"></a>
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Para
        referenciarlos con otras personas naturales o jurídicas.</span></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol>
      <ol start="3">
        <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Empleados</b></span></font></font></p></li>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Para
        guardar y verificar las hojas de vida.</span></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 0.64cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="2">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Para
      ejecutar y cumplir con el contrato de trabajo y demás obligaciones
        que como empleador le corresponden por ley.</span></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="3">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Administrar
      y operar, directamente o por conducto de terceros, los procesos de
      selección y vinculación de personal, incluyendo la evaluación y
      calificación de los participantes y la verificación de referencias
        laborales y personales, y la realización de estudios de seguridad.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="4">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Desarrollar
      las actividades propias de la gestión de recursos humanos tales
      como nómina, afiliaciones a entidades del sistema general de
      seguridad social, actividades de bienestar y salud ocupacional,
        ejercicio de la potestad sancionatoria del empleador, entre otras.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="5">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Realizar
      los pagos necesarios derivados de la ejecución del contrato de
      trabajo y/o su terminación, y las demás prestaciones sociales a
        que haya lugar de conformidad con la ley aplicable.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="6">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Contratar
      beneficios laborales con terceros, tales como seguros de vida,
        gastos médicos, entre otros.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="7">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Notificar
      a contactos autorizados en caso de emergencias durante el horario de
        trabajo o con ocasión del desarrollo del mismo.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="8">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Coordinar
      el desarrollo profesional de los empleados, el acceso de los
        empleados a los recursos informáticos y asistir en su utilización.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="9">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Transferir
      y transmitir la información de los empleados a Encargados del
      Tratamiento en Colombia y en el exterior cuando ello sea necesario
        para el desarrollo de sus operaciones y gestión de nómina.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="10">
      <li><p align="justify" style="margin-bottom: 0.26cm; border: none; padding: 0cm; line-height: 100%; background: #ffffff"><a name="_Hlk495305929"></a>
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Los
      demás fines necesarios para dar cumplimiento al contrato de
        trabajo.</span></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 0.64cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol>
      <ol start="4">
        <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
        <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><b>Finalidades
          aplicables a todos</b></span></font></font></font></p></li>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>
    <ol type="a">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Para
      el fortalecimiento de las relaciones con sus clientes y proveedores,
      mediante el envío de información relevante, la toma de pedidos y
        evaluación de la calidad de los productos de ABACO LATAM S.A.S.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 0.64cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="2">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Para
      la determinación de obligaciones pendientes, la consulta de
      información financiera e historia crediticia y el reporte a
      centrales de información de obligaciones incumplidas, respecto de
        sus deudores en los términos de la Ley 1266 de 2008.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%"><a name="_Hlk495305637"></a>
    <br/>
    </p>

    <ol type="a" start="3">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%"><a name="_Hlk495305681"></a>
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Controlar
      el acceso a las oficinas de ABACO LATAM S.A.S., y establecer medidas
      de seguridad, incluyendo el establecimiento de zonas
        videovigiladas.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="4">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Dar
      respuesta a consultas, peticiones, quejas y reclamos que sean
      realizadas por los titulares y transmitir los Datos Personales a
      organismos de control y demás autoridades que en virtud de la ley
        aplicable deban recibir los Datos Personales.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="5">
      <li><p align="justify" style="margin-bottom: 0cm; line-height: 100%"><a name="_Hlk498445062"></a><a name="_Hlk490746017"></a>
      <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Registrar
      los datos personales en los sistemas de información de ABACO LATAM
        S.A.S. y en sus bases de datos comerciales y operativas.&nbsp;</span></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>

    <ol start="4">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
      <font color="#000000"> <font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><b>DERECHOS
        DE LOS TITULARES DE DATOS </b></span></span></font></font></font>
      </p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">Conforme
    lo dispone la Ley 1581 de 2012, los titulares de datos personales
    tienen derecho a:</font></font></span></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">Conocer,
      actualizar y rectificar sus datos personales frente a los
      Responsables del Tratamiento o Encargados del Tratamiento. Este
      derecho se podrá ejercer, entre otros frente a datos parciales,
      inexactos, incompletos, fraccionados, que induzcan a error, o
      aquellos cuyo Tratamiento esté expresamente prohibido o no haya
        sido autorizado.</font></font></span></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="2">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">Solicitar
      prueba de la autorización otorgada al Responsable del Tratamiento
      salvo cuando expresamente se exceptúe como requisito para el
      Tratamiento, de conformidad con lo previsto en el artículo 10 de la
        Ley 1581 de 2012.</font></font></span></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="3">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">Ser
      informado por el Responsable del Tratamiento o el Encargado del
      Tratamiento, previa solicitud, respecto del uso que le ha dado a sus
        datos personales.</font></font></span></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="4">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">Presentar
      ante la Superintendencia de Industria y Comercio quejas por
      infracciones a lo dispuesto en la presente ley y las demás normas
        que la modifiquen, adicionen o complementen.</font></font></span></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol type="a" start="5">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">Revocar
      la autorización y/o solicitar la supresión del dato cuando en el
      Tratamiento no se respeten los principios, derechos y garantías
      constitucionales y legales. La revocatoria y/o supresión procederá
      cuando la Superintendencia de Industria y Comercio haya determinado
      que en el Tratamiento el Responsable o Encargado han incurrido en
        conductas contrarias a esta ley y a la Constitución.</font></font></span></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <ol type="a" start="6">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
      <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">Acceder
      en forma gratuita a sus datos personales que hayan sido objeto de
        Tratamiento.</font></font></span></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 0.64cm; margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>
    <ol start="5">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><b>PERSONA
      RESPONSABLE DE LA ATENCIÓN DE PETICIONES, CONSULTAS Y RECLAMOS ANTE
        LA CUAL EL TITULAR DE LA INFORMACIÓN</b></span></span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">La
    Gerencia VICTORIA BLANCO ALEGRIA de ABACO LATAM S.A.S. será la
    encargada de atender las peticiones, consultas y reclamos de los
    titulares de la información. Cualquier solicitud debe ser enviada al
    correo electrónico info@abacolatam.com con el fin de ejercer los
    derechos a conocer, actualizar, rectificar y suprimir los datos y
    revocar la autorización otorgados por la ley y por esta Política de
    Tratamiento de Información. </span></font></font></font>
    </p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>

    <ol start="6">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><b>PROCEDIMIENTO
      PARA QUE LOS TITULARES DE LA INFORMACIÓN PUEDAN EJERCER LOS
      DERECHOS A CONOCER, ACTUALIZAR, RECTIFICAR Y SUPRIMIR INFORMACIÓN Y
        REVOCAR LA AUTORIZACIÓN.</b></span></span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>
    <ol>
      <ol>
        <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <span style="display: inline-block; border: none; padding: 0cm"><b><font face="Arial, serif"><font size="2" style="font-size: 11pt">Consultas</font></font></b></span></p></li>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">ABACO
    LATAM S.A.S. dispone del correo electrónico info@abacolatam.com para
    que el titular, sus causahabientes, sus representantes y apoderados,
    y los representantes de menores de edad titulares, formulen consultas
    respecto de cuáles son los datos personales del titular que reposan
    en las bases de datos de ABACO LATAM S.A.S.&nbsp;</font></font></span></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol>
      <ol>
        <ol>
          <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">Si
          el solicitante tuviere capacidad para formular la consulta, en los
          términos señalados en le Ley 1581 de 2012 y sus decretos
          reglamentarios, ABACO LATAM S.A.S. recopilará toda la información
          sobre el titular que esté contenida las bases de datos de ABACO
            LATAM S.A.S. y se la hará conocer al solicitante.</font></font></span></p></li>
        </ol>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>

    </p>
    <ol>
      <ol>
        <ol start="2">
          <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">El
          responsable de atender la consulta, según se señala en el
          numeral 4 arriba, dará respuesta al solicitante siempre y cuando
          tuviere derecho a ello por ser el titular del dato personal, su
          causahabiente, apoderado, representante, o sea el responsable
          legal en el caso de menores de edad. Esta respuesta se enviará
          dentro de los diez (10) días hábiles contados a partir de la
          fecha en la que la solicitud fue recibida por la ABACO LATAM
            S.A.S..&nbsp;</font></font></span></p></li>
        </ol>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%">
    <br/>
    </p>

    <ol>
      <ol>
        <ol start="3">
          <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">En
          caso de que la solicitud no pueda ser atendida a los diez (10)
          hábiles, se contactará al solicitante para comunicarle los
          motivos por los cuales el estado de su solicitud se encuentra en
          trámite. Para ello se utilizará el mismo medio o uno similar al
            que fue utilizado por el titular para su comunicar su solicitud.</font></font></span></p></li>
        </ol>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol>
      <ol>
        <ol start="4">
          <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">La
          respuesta definitiva a todas las solicitudes no tardará más de
          quince (15) días hábiles desde la fecha en la que la solicitud
          inicial fue recibida por ABACO LATAM S.A.S. al correo electrónico
            info@abacolatam.com</font></font><span lang="es-CO"><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span style="text-decoration: none">.</span></span></font></font></font></span></span></p></li>
        </ol>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <ol>
      <ol start="2">
        <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <span style="display: inline-block; border: none; padding: 0cm"><b><font face="Arial, serif"><font size="2" style="font-size: 11pt">Reclamos</font></font></b></span></p></li>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <br/>

    </p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">ABACO
    LATAM S.A.S. dispone del correo electrónico info@abacolatam.com para
    que el titular, sus causahabientes, sus representantes y apoderados,
    y los representantes de menores de edad titulares, formulen reclamos
    respecto de (i) datos personales tratados por la empresa que deben
    ser objeto de corrección, actualización o supresión, o (ii) el
    presunto incumplimiento de las normas aplicables en la materia.</font></font></span></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <ol>
      <ol>
        <ol>
          <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">El
          reclamo deberá ser presentado por el Titular, sus causahabientes
          o representantes o acreditados de conformidad con la Ley 1581 y
          sus decretos reglamentarios al correo electrónico
          </font></font>info@abacolatam.com<font face="Arial, serif"><font size="2" style="font-size: 11pt">
            y deberá contener la siguiente información:&nbsp;</font></font></span></p></li>
        </ol>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <ol type="a">
      <li><p align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Nombre
        y documento de identificación del titular.&nbsp;</span></font></font></font></p></li>
      <li><p align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Una
      descripción de los hechos que dan lugar al reclamo y el objetivo
      perseguido (actualización, corrección o supresión, o cumplimiento
        de deberes).</span></font></font></font></p></li>
      <li><p align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">La
        dirección y datos de contacto e identificación del reclamante.</span></font></font></font></p></li>
      <li><p align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Acompañarse
        por toda la documentación que el reclamante quiera hacer valer.</span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.91cm; margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%">
    <br/>
    </p>

    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">ABACO
    LATAM S.A.S. antes de atender el reclamo verificará la identidad del
    titular del dato personal, su representante o apoderado, o la
    acreditación de que hubo una estipulación por otro o para otro.
    Para ello puede exigir la cédula de ciudadanía o documento de
    identificación original del titular, y los poderes especiales,
    generales o documentos que se exijan según sea el caso.</font></font></span></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>
    <ol>
      <ol>
        <ol start="2">
          <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">Si
          el reclamo o la documentación adicional están incompletos, ABACO
          LATAM S.A.S. requerirá al reclamante por una sola vez dentro de
          los cinco (5) días siguientes a la recepción del reclamo para
          que subsane las fallas. Si el reclamante no presenta la
          documentación e información requerida dentro de los dos (2)
          meses siguientes a la fecha del reclamo inicial, se entenderá que
            ha desistido del reclamo.</font></font></span></p></li>
        </ol>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <ol>
      <ol>
        <ol start="3">
          <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">Si
          por cualquier hecho la persona que recibe el reclamo no es
          competente para resolverlo, dará traslado la Gerencia General
          dentro de los dos (2) días hábiles siguientes a haber recibido
            el reclamo, e informará de dicha remisión al reclamante.</font></font></span></p></li>
        </ol>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <ol>
      <ol>
        <ol start="4">
          <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">Una
          vez recibido el reclamo con la documentación completa, se
          incluirá en la base de datos de ABACO LATAM S.A.S. donde reposen
          los datos del titular sujetos a reclamo una leyenda que diga
          “reclamo en trámite” y el motivo del mismo, en un término no
          mayor a dos (2) días hábiles. Esta leyenda deberá mantenerse
            hasta que el reclamo sea decidido.</font></font></span></p></li>
        </ol>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 100%">
    <br/>
    </p>

    <ol>
      <ol>
        <ol start="5">
          <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; line-height: 100%">
          <span style="display: inline-block; border: none; padding: 0cm"><font face="Arial, serif"><font size="2" style="font-size: 11pt">El
          término máximo para atender el reclamo será de quince (15) días
          hábiles contados a partir del día siguiente a la fecha de su
          recibo. Cuando no fuere posible atender el reclamo dentro de dicho
          término, se informará al interesado los motivos de la demora y
          la fecha en que se atenderá su reclamo, la cual en ningún caso
          podrá superar los ocho (8) días hábiles siguientes al
            vencimiento del primer término.</font></font></span></p></li>
        </ol>
      </ol>
    </ol>
    <p lang="es-CO" align="justify" style="margin-left: 0.39cm; margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>

    <ol start="7">
      <li><p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
      <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO"><span lang="es-CO"><b>FECHA
      DE ENTRADA EN VIGENCIA DE LA POLÍTICA DE TRATAMIENTO DE LA
        INFORMACIÓN Y PERÍODO DE VIGENCIA DE LA BASE DE DATOS.</b></span></span></font></font></font></p></li>
    </ol>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>

    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">La
    presente Política de Tratamiento de la Información de ABACO LATAM
    S.A.S. rige a partir del</span> 25/02/2022<span lang="es-CO">. </span></font></font></font>
    </p>
    <p lang="es-CO" align="justify" style="margin-left: 0.39cm; margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>

    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">Los
    datos personales que sean recolectados, almacenados, transmitidos,
    transferidos, procesados y usados permanecerán en la base de datos
    de ABACO LATAM S.A.S., con base en el criterio de temporalidad y
    necesidad, durante el tiempo que sea necesario para las finalidades
    mencionadas en esta Política, para los cuales fueron recolectados.&nbsp;</span></font></font></font></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>

    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>

    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <br/>
    </p>

    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">ABACO
    LATAM S.A.S.</span></font></font></font></p>
    <p lang="es-CO" align="justify" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 100%; text-decoration: none">
    <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt"><span lang="es-CO">NIT
    </span><span lang="es-ES-u-co-trad">901.102.558-4</span></font></font></font></p>
    </div>
    <div class="row-12">
      <router-link to="/">Volver</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Legal'
}
</script>



// WEBPACK FOOTER //
// src/components/Legal.vue